import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { applyMixins } from 'rxjs/internal/util/applyMixins'

import { environment } from 'environments/environment'

import { AttachmentsApi } from '@app/components/attachments/attachments.api'
import {
  BaseApiV2,
  ListableApi,
  RetrievableApi,
} from '@app/components/generic/utilities'
import { WorkflowApi } from '@app/components/workflows/workflows.api'

import { Confirmation, ConfirmationWorkflowPayload } from './confirmations'
import { ConfirmationTransition } from './confirmations.constants'

@Injectable({
  providedIn: 'root',
})
export class ConfirmationsApi extends BaseApiV2<Confirmation> {
  protected readonly http = inject(HttpClient)
  public readonly baseUrl = 'logistics/confirmations'
  public readonly codeField = 'code'

  public acceptWithUpload (instanceCode: string, theFiles: File[], data: Record<string, string> = {},
    detail: Record<string, string|number|boolean|Array<string| number>> = {}): Observable<Confirmation> {
    const formData: FormData = new FormData()
    theFiles.forEach(theFile => {
      formData.append('theFile', theFile, theFile.name)
    })
    for (const key in data) {
      formData.append(key, data[key])
    }
    formData.append('detail', JSON.stringify(detail))
    return this.http.post<Confirmation>(`${environment.apiRoot}/api/${this.baseUrl}/${instanceCode}/accept-with-upload/`, formData)
  }
}

export interface ConfirmationsApi extends
  ListableApi<Confirmation>,
  RetrievableApi<Confirmation>,
  AttachmentsApi<Confirmation>,
  WorkflowApi<ConfirmationWorkflowPayload, ConfirmationTransition> {}
applyMixins(ConfirmationsApi, [ListableApi, RetrievableApi, AttachmentsApi, WorkflowApi])
